import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { addDoc, collection } from 'firebase/firestore'
import { formatISO } from 'date-fns'
import { DMA_SYSTEM, EVENT_STATUS, SESSION_KEY } from 'app-constants'
import { useFirebase } from 'hooks/use-firebase'
import { getIsDmaStorage } from 'utils'

export function useFirebaseEvent() {
  const { database } = useFirebase()
  const { contract } = useSelector(state => state)

  const sendEvent = useCallback(
    async (event, status = EVENT_STATUS.SUCCESS, statusCode = null) => {
      if (database) {
        try {
          const isDma = getIsDmaStorage()
          const { fluxo, jornada, label, ordem, title } = event
          const sessionId = localStorage.getItem(SESSION_KEY)
          const contractId = contract?.selected?.id || null
          const system = isDma ? DMA_SYSTEM : null
          const data = {
            createdAt: formatISO(Date.now()),
            label,
            title,
            jornada,
            fluxo,
            ordem,
            status,
            contract_number: contractId,
            status_code: statusCode,
            session_id: sessionId,
            sistema: system,
          }

          const docRef = await addDoc(collection(database, 'events'), data)

          return docRef.id
        } catch (error) {
          console.error(error)
        }
      }
    },
    [database, contract]
  )

  return { sendEvent }
}
